export default "/assets/images/caught-me-cleaning.c139f7e370fee072.png";